import React, { Component } from 'react';
import App from './App';
import { Provider } from 'react-redux';
import { MixpanelProvider } from 'react-mixpanel';
import mixpanel from 'mixpanel-browser';

import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import store from '@progressivebeef/shared/src/store/react';
import PlatformService from '@progressivebeef/shared/src/services/plaform';
import AlertModal from './components/AlertModal';

import { ToastContainer } from 'react-toastify';
import PbLoader from './components/PbLoader';

// Create the router configuration
const routerConfig = [
  {
    path: "/*",
    element: <App />
  }
];

const routerOptions = {};
if (process.env.REACT_APP_BASE_NAME && process.env.REACT_APP_BASE_NAME !== '') {
  routerOptions.basename = process.env.REACT_APP_BASE_NAME;
}

const router = createBrowserRouter(routerConfig, routerOptions);

export default class BootSetup extends Component {
  render() {
    PlatformService.isWeb = true;

    return (
      <>
        <Provider store={store}>
          <AlertModal></AlertModal>
          <MixpanelProvider mixpanel={mixpanel}>
            <ToastContainer className="customToast" hideProgressBar={true} />
            <PbLoader></PbLoader>
            <RouterProvider router={router} />
          </MixpanelProvider>
        </Provider>
      </>
    );
  }
}
